export default __webpack_public_path__ + "static/media/token_xdc.ac306839.svg";